import { Field, NumericInput, RadioGroup } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import { NuclearDensityGaugeMode } from 'Components/Worksheets/NuclearFieldDensityWorksheet/types';
import { useSelector } from 'react-redux';

let MeasurementsModeSectionBase: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }): JSX.Element => {
  const directTransmissionMode =
    useSelector(createWorksheetSelector!('GaugeMode')) === NuclearDensityGaugeMode.DirectTransmission;

  return (
    <ListFieldSection>
      <Field
        input={<RadioGroup />}
        name="GaugeMode"
        options={[
          { label: 'Direct Transmission', value: NuclearDensityGaugeMode.DirectTransmission },
          { label: 'Backscatter', value: NuclearDensityGaugeMode.Backscatter },
        ]}
      />
      <Field input={<NumericInput />} name="ProbeDepth" visible={directTransmissionMode} />
    </ListFieldSection>
  );
};

const MeasurementsModeSection = withInjectedProps(MeasurementsModeSectionBase);
export { MeasurementsModeSection };
